import {
  HeroSection,
  CompanySection,
  FeatureSection,
  ContactSection,
} from './Vision/index';

function Vision() {
  return (
    <div className="page vision-page">
      <HeroSection />
      <CompanySection />
      <FeatureSection />
      <ContactSection />
    </div>
  );
}

export default Vision;
